import React from 'react'
import './devRibbon.less'

const DevRibbon = () => <div className='corner-ribbon'>Staging</div>
export default DevRibbon
